import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import {TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import Stack from "@mui/material/Stack";
import {useNavigate} from "react-router-dom";

function EmailCapture({email, setEmail, nextPath, showBackButton}) {
    const history = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        history(nextPath);
    };

    return (
        <React.Fragment>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            <ValidatorForm onSubmit={handleSubmit}>
                <Container disableGutters maxWidth="sm" component="main" sx={{ pt: 8, pb: 6 }}>
                    <Stack direction="column" justifyContent="end" spacing={2}>
                        <Typography component="h1" variant="h5" align="center" color="text.primary" gutterBottom>
                            What is your email address?
                        </Typography>
                        <TextValidator
                            onChange={e => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            label="Email address"
                            autoComplete="email"
                            value={email}
                            validators={['required', 'isEmail']}
                            errorMessages={['this field is required', 'must be a valid email address']}
                            fullWidth
                        />
                        <Button type="submit" variant="contained" color="primary">
                            Continue
                        </Button>
                        {showBackButton && (
                            <Button onClick={() => history('/')} variant="outlined" color="secondary">
                                Back to pricing
                            </Button>
                        )}
                    </Stack>
                </Container>
            </ValidatorForm>
        </React.Fragment>
    );
}

export default EmailCapture;
